import styled from "styled-components"
import { theme } from "../../theme"

export const InputWrapper = styled.div`
  border-radius: 0.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};

  padding-left: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;

  input {
    width: calc(100% - 3rem);
    border: none;
  }

  ${theme.mQ.MEDIA_MIN_LARGE} {
    width: 60%;
  }
`

export const ClearButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-right: 1rem;

  svg {
    height: 2rem;
  }
`

export const SearchButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-left: 0.1rem solid ${({ theme }) => theme.colors.borderLight};

  background-color: ${({ theme }) => theme.colors.turquoiseDark};
  padding: 1.5rem;
  border-radius: 0 0.5rem 0.5rem 0;
  &:hover {
    background-color: ${({ theme }) => theme.colors.turquoiseDarker}
  }

  svg {
    fill: ${({ theme }) => theme.colors.white};
    padding: 0 0.3rem;
    height: 1.3rem;
  }
`

export const FreeTrialBadge = styled.span`
  background: ${(p) => p.theme.colors.turquoiseDark};
  color: white;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 0.6rem;
  border-radius: 0.3rem;
  margin-left: 0.5rem;
  vertical-align: middle;
`
